import Navbar from '@/pages/home/components/Navbar';
import HeroSection from '@/pages/home/components/HeroSection';
import CategorySection from '@/pages/home/components/CategorySection';
import BenefitsSection from '@/pages/home/components/BenefitsSection';
import HowItWorks from '@/pages/home/components/HowItWorks';
import SafetySection from '@/pages/home/components/SafetySection';
import FAQSection from '@/pages/home/components/FAQSection';
import ArticleGridSection from '@/pages/home/components/ArticleGridSection';
import Footer from '@/pages/home/components/Footer';
import JsonLd from '@/components/base/JsonLd';
import { Link } from 'react-router-dom';

const SITE_URL = 'https://oopbuyspread.hair';

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'OOPBuy Spreadsheet',
  url: SITE_URL,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/5133451b25e408e4a25e4df97e05add8.jpeg',
  description:
    'OOPBuy Spreadsheet ist eine strukturierte Übersichtsplattform für Produkte aus 14 Kategorien. Die führende deutsche Informationsplattform für Produktsuche, Vergleiche und Einkaufs-Guides.',
  sameAs: [SITE_URL],
};

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'OOPBuy Spreadsheet',
  url: SITE_URL,
  description:
    'Die deutsche Plattform für OOPBuy Spreadsheet Übersichten, Produktkategorien, Vergleiche und hilfreiche Einkaufs-Guides.',
  inLanguage: 'de',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${SITE_URL}/?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <BenefitsSection />
        <HowItWorks />

        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <p className="text-xs md:text-sm font-medium text-accent-600 uppercase tracking-wider mb-2">
                Vergleich
              </p>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
                OOPBuy Spreadsheet Vergleich 2026
              </h2>
              <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-2xl mx-auto">
                Ein detaillierter Vergleich der wichtigsten Funktionen und Eigenschaften, damit du die beste Wahl treffen kannst.
              </p>
            </div>

            <div className="overflow-hidden rounded-lg border border-background-200/70 bg-white max-w-3xl mx-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-background-100">
                    <th className="text-left px-5 py-3.5 font-semibold text-foreground-900 border-b border-background-200/70">
                      Funktion
                    </th>
                    <th className="text-left px-5 py-3.5 font-semibold text-foreground-900 border-b border-background-200/70">
                      OOPBuy Spreadsheet
                    </th>
                    <th className="text-left px-5 py-3.5 font-semibold text-foreground-900 border-b border-background-200/70">
                      Alternative
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-100">
                    <td className="px-5 py-3.5 text-foreground-700">Kategorien</td>
                    <td className="px-5 py-3.5 text-primary-600 font-medium">
                      <i className="ri-check-line mr-1"></i>14 Kategorien
                    </td>
                    <td className="px-5 py-3.5 text-foreground-500">Begrenzt</td>
                  </tr>
                  <tr className="border-b border-background-100">
                    <td className="px-5 py-3.5 text-foreground-700">Aktualisierung</td>
                    <td className="px-5 py-3.5 text-primary-600 font-medium">
                      <i className="ri-check-line mr-1"></i>Regelmäßig
                    </td>
                    <td className="px-5 py-3.5 text-foreground-500">Unregelmäßig</td>
                  </tr>
                  <tr className="border-b border-background-100">
                    <td className="px-5 py-3.5 text-foreground-700">Übersicht</td>
                    <td className="px-5 py-3.5 text-primary-600 font-medium">
                      <i className="ri-check-line mr-1"></i>Sehr gut
                    </td>
                    <td className="px-5 py-3.5 text-foreground-500">Gut</td>
                  </tr>
                  <tr>
                    <td className="px-5 py-3.5 text-foreground-700">Anfänger geeignet</td>
                    <td className="px-5 py-3.5 text-primary-600 font-medium">
                      <i className="ri-check-line mr-1"></i>Ja
                    </td>
                    <td className="px-5 py-3.5 text-foreground-500">Teilweise</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="text-center mt-8">
              <Link
                to="/artikel/oopbuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                Vollständigen Vergleich lesen
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        <SafetySection />

        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              Bereit, die besten Produkte zu entdecken?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto mb-8">
              Starte jetzt mit OOPBuy Spreadsheet und finde alle Produkte übersichtlich in einer Plattform.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 text-sm font-medium bg-foreground-900 text-white rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                oopbuy spreadsheet
                <i className="ri-external-link-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 text-sm font-medium bg-accent-500 text-white rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                buy it now
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </section>

        <FAQSection />
        <ArticleGridSection />
      </main>
      <Footer />
      <JsonLd data={organizationJsonLd} />
      <JsonLd data={websiteJsonLd} />
    </>
  );
}